import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/hooks/use-toast";
import { Sidebar, SidebarContent, SidebarFooter, SidebarHeader } from "@/components/ui/sidebar";
import { useSession } from "@/hooks/use-session";
import { AdminSidebarHeader } from "./admin-sidebar/AdminSidebarHeader";
import { SidebarSection } from "./admin-sidebar/SidebarSection";
import { AdminSidebarFooter } from "./admin-sidebar/AdminSidebarFooter";
import { useSidebarData } from "./admin-sidebar/useSidebarData";
import { useAdminPermissions } from "@/hooks/useAdminPermissions";
export const AdminSidebar = () => {
  const navigate = useNavigate();
  const {
    toast
  } = useToast();
  const {
    clearSessionAndRedirect
  } = useSession();
  const {
    adminItems,
    clientItems,
    apiItems,
    financialItems,
    unpaidCount,
    unapprovedCount
  } = useSidebarData();
  const {
    menuAccess
  } = useAdminPermissions();

  // Filter menu items based on role permissions
  const filteredAdminItems = adminItems.filter(item => {
    if (item.title === "Dashboard" && menuAccess.dashboard) return true;
    if (item.title === "Products" && menuAccess.products) return true;
    if (item.title === "Settings" && menuAccess.settings) return true;
    return false;
  });
  const filteredClientItems = clientItems.filter(item => {
    if (item.title === "Schools" && menuAccess.schools) return true;
    if (item.title === "Users" && menuAccess.users) return true;
    if (item.title === "Staff" && menuAccess.staff) return true;
    if (item.title === "Admin Users" && menuAccess.adminUsers) return true;
    return false;
  });
  const filteredFinancialItems = financialItems.filter(item => {
    if (item.title === "Plans" && menuAccess.plans) return true;
    if (item.title === "Subscriptions" && menuAccess.subscriptions) return true;
    if (item.title === "Discounts" && menuAccess.discounts) return true;
    return false;
  });
  const filteredApiItems = apiItems.filter(item => {
    if (item.title === "Pricing API" && menuAccess.pricingApi) return true;
    if (item.title === "Payment API" && menuAccess.paymentApi) return true;
    if (item.title === "Subscription Status API" && menuAccess.subscriptionStatusApi) return true;
    return false;
  });
  const handleLogout = async () => {
    try {
      clearSessionAndRedirect();
      const {
        error
      } = await supabase.auth.signOut();
      if (error) {
        console.error('Logout error:', error);
        toast({
          title: "Logged out",
          description: "You have been logged out successfully."
        });
        return;
      }
      toast({
        title: "Success",
        description: "You have been logged out."
      });
    } catch (error) {
      console.error('Logout error:', error);
      toast({
        title: "Logged out",
        description: "You have been logged out successfully."
      });
    }
  };
  return <Sidebar>
      <SidebarHeader className="rounded-lg">
        <AdminSidebarHeader />
      </SidebarHeader>
      <SidebarContent>
        {filteredAdminItems.length > 0 && <SidebarSection title="Admin" items={filteredAdminItems} />}
        
        {filteredClientItems.length > 0 && <SidebarSection title="Client" items={filteredClientItems} badgeCount={menuAccess.users ? {
        itemTitle: "Users",
        count: unapprovedCount
      } : undefined} />}
        
        {filteredFinancialItems.length > 0 && <SidebarSection title="Financial" items={filteredFinancialItems} badgeCount={menuAccess.subscriptions ? {
        itemTitle: "Subscriptions",
        count: unpaidCount
      } : undefined} />}
        
        {filteredApiItems.length > 0 && <SidebarSection title="API" items={filteredApiItems} />}
      </SidebarContent>
      <SidebarFooter>
        <AdminSidebarFooter onLogout={handleLogout} />
      </SidebarFooter>
    </Sidebar>;
};